import React from 'react';
import { apiPaths } from 'app/services/api';
import DataView from '../../DataView/DataView';
import { SellerFields } from './SellerForm';
const SellerView = () => {
  return <DataView apipath={apiPaths.SELLERS} columns={SellerFields} />;
};

export default SellerView;
